module.exports = __webpack_public_path__ + "static/media/argentina.e213052a.JPG";